import React from "react";


const width = '50px'


export const Python = () => (
    <svg viewBox="0 -0.5 256 256"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid">
        <defs>
            <linearGradient
                x1="12.9593594%"
                y1="12.0393928%"
                x2="79.6388325%"
                y2="78.2008538%"
                id="linearGradient-1">
                <stop stopColor="#387EB8" offset="0%" />
                <stop stopColor="#366994" offset="100%" />
            </linearGradient>
            <linearGradient
                x1="19.127525%"
                y1="20.5791813%"
                x2="90.7415328%"
                y2="88.4290372%"
                id="linearGradient-2">
                <stop stopColor="#FFE052" offset="0%" />
                <stop stopColor="#FFC331" offset="100%" />
            </linearGradient>
        </defs>
        <g>
            <path
                d="M126.915866,0.0722755491 C62.0835831,0.0722801733 66.1321288,28.1874648 66.1321288,28.1874648 L66.2044043,57.3145115 L128.072276,57.3145115 L128.072276,66.0598532 L41.6307171,66.0598532 C41.6307171,66.0598532 0.144551098,61.3549438 0.144551098,126.771315 C0.144546474,192.187673 36.3546019,189.867871 36.3546019,189.867871 L57.9649915,189.867871 L57.9649915,159.51214 C57.9649915,159.51214 56.8001363,123.302089 93.5968379,123.302089 L154.95878,123.302089 C154.95878,123.302089 189.434218,123.859386 189.434218,89.9830604 L189.434218,33.9695088 C189.434218,33.9695041 194.668541,0.0722755491 126.915866,0.0722755491 L126.915866,0.0722755491 L126.915866,0.0722755491 Z M92.8018069,19.6589497 C98.9572068,19.6589452 103.932242,24.6339846 103.932242,30.7893845 C103.932246,36.9447844 98.9572068,41.9198193 92.8018069,41.9198193 C86.646407,41.9198239 81.6713721,36.9447844 81.6713721,30.7893845 C81.6713674,24.6339846 86.646407,19.6589497 92.8018069,19.6589497 L92.8018069,19.6589497 L92.8018069,19.6589497 Z"
                fill="url(#linearGradient-1)"
            />
            <path
                d="M128.757101,254.126271 C193.589403,254.126271 189.540839,226.011081 189.540839,226.011081 L189.468564,196.884035 L127.600692,196.884035 L127.600692,188.138693 L214.042251,188.138693 C214.042251,188.138693 255.528417,192.843589 255.528417,127.427208 C255.52844,62.0108566 219.318366,64.3306589 219.318366,64.3306589 L197.707976,64.3306589 L197.707976,94.6863832 C197.707976,94.6863832 198.87285,130.896434 162.07613,130.896434 L100.714182,130.896434 C100.714182,130.896434 66.238745,130.339138 66.238745,164.215486 L66.238745,220.229038 C66.238745,220.229038 61.0044225,254.126271 128.757101,254.126271 L128.757101,254.126271 L128.757101,254.126271 Z M162.87116,234.539597 C156.715759,234.539597 151.740726,229.564564 151.740726,223.409162 C151.740726,217.253759 156.715759,212.278727 162.87116,212.278727 C169.026563,212.278727 174.001595,217.253759 174.001595,223.409162 C174.001618,229.564564 169.026563,234.539597 162.87116,234.539597 L162.87116,234.539597 L162.87116,234.539597 Z"
                fill="url(#linearGradient-2)"
            />
        </g>
    </svg>

)

export const Bash = () => (
    <svg width={width} viewBox="-16 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
        <g>
            <path d="M207.953496,52.161792 L127.317154,4.28699154 C117.73318,-1.42899718 105.786545,-1.42899718 96.2025707,4.28699154 L15.5500822,52.161792 C5.848665,58.0143618 -0.0579442252,68.5395346 0.000428679482,79.8694336 L0.000428679482,175.602888 C-0.0522462707,186.927041 5.85362572,197.444768 15.5500822,203.294383 L96.186424,251.153037 C105.771373,256.86549 117.716059,256.86549 127.301008,251.153037 L207.937349,203.294383 C217.644962,197.44581 223.55812,186.9199 223.50315,175.586741 L223.50315,79.8694336 C223.561523,68.5395346 217.654913,58.0143618 207.953496,52.161792 Z" fill="#FFFFFF">

            </path>
            <path d="M208.411532,52.276683 L127.597582,4.29643402 C117.992498,-1.43214467 106.019549,-1.43214467 96.4144654,4.29643402 L15.5843327,52.276683 C5.86154721,58.1421436 -0.0580718526,68.6904991 0.000429623687,80.0453532 L0.000429623687,175.989669 C-0.0523613478,187.338765 5.86651886,197.879657 15.5843327,203.742157 L96.3982832,251.706224 C106.004343,257.431259 117.975339,257.431259 127.581399,251.706224 L208.39535,203.742157 C218.124345,197.880703 224.050527,187.331607 223.995435,175.973487 L223.995435,80.0453532 C224.053937,68.6904991 218.134318,58.1421436 208.411532,52.276683 Z M99.2301697,246.803014 L18.4162192,198.838948 C10.4300926,193.999639 5.56585934,185.327547 5.59969728,175.989669 L5.59969728,80.0453532 C5.56264048,70.7066408 10.4277023,62.033071 18.4162192,57.1960744 L99.2301697,9.21582548 C107.095348,4.52357839 116.900517,4.52357839 124.765695,9.21582548 L205.514917,57.1960744 C212.17156,61.2279088 216.712503,67.9889997 217.926671,75.6761569 C215.240424,69.9638372 209.20446,68.3941629 202.1652,72.4397151 L125.768992,119.756494 C116.237671,125.306991 109.214593,131.569506 109.19841,143.058874 L109.19841,237.271693 C109.19841,244.149132 111.965568,248.59924 116.237671,249.909999 C114.838668,250.166379 113.420175,250.301731 111.997932,250.314554 C107.503971,250.311263 103.093756,249.098314 99.2301697,246.803014 Z" fill="#2F3A3E">

            </path>
            <path d="M187.007319,185.05984 L166.920894,197.072944 C166.382945,197.289147 166.022425,197.801466 166.000535,198.380822 L166.000535,203.660774 C166.000535,204.30664 166.436494,204.564987 166.969334,204.2582 L187.362545,191.857577 C187.861962,191.483188 188.100868,190.854486 187.976118,190.242913 L187.976118,185.608826 C187.959971,185.0114 187.491719,184.753054 187.007319,185.05984 Z" fill="#3AB14A">

            </path>
            <path d="M144.262952,140.831868 C144.908817,140.508935 145.441657,140.831868 145.457803,141.752226 L145.52239,148.75987 C147.937868,147.662506 150.63266,147.335523 153.240486,147.823365 C153.741032,147.952538 153.950938,148.630697 153.757179,149.438029 L152.223247,155.5899 C152.106964,156.054178 151.867023,156.478259 151.528942,156.817045 C151.410206,156.934194 151.274035,157.032237 151.125276,157.107685 C150.94275,157.206405 150.732219,157.240546 150.52785,157.204565 C147.984993,156.641458 145.323113,157.068744 143.084247,158.399417 C139.810579,159.87411 137.670697,163.093345 137.578241,166.682645 C137.578241,169.911974 139.192905,170.800039 144.828084,170.896919 C152.271687,171.026092 155.501016,174.271568 155.581749,181.779758 C155.404525,189.616874 151.790949,196.979831 145.700003,201.914623 L145.829176,208.793094 C145.817697,209.647405 145.37394,210.437656 144.650471,210.892157 L140.581517,213.233421 C139.935651,213.556354 139.402812,213.233421 139.386665,212.329209 L139.386665,205.563765 C135.89899,207.016963 132.362875,207.356042 130.102345,206.45183 C129.682532,206.290364 129.488772,205.660645 129.666385,204.934046 L131.13573,198.717587 C131.24746,198.225629 131.499922,197.776809 131.862329,197.425856 C131.977267,197.315759 132.107853,197.223261 132.249848,197.151363 C132.460373,197.056728 132.701336,197.056728 132.911861,197.151363 C135.790274,197.931772 138.860474,197.542919 141.453436,196.069538 C145.195213,194.264929 147.626918,190.533412 147.766774,186.381551 C147.766774,182.893876 145.845323,181.440678 141.308116,181.408385 C135.446884,181.408385 130.005465,180.27812 129.892438,171.720398 C130.027305,164.244122 133.498017,157.21978 139.354372,152.570478 L139.063732,145.530541 C139.061125,144.663931 139.507025,143.857647 140.242437,143.399184 L144.262952,140.831868 Z" fill="#FFFFFF">

            </path>
        </g>
    </svg>
)

export const Javascript = () => (
    <svg
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        aria-label="JavaScript"
        role="img"
        viewBox="0 0 512 512">
        <rect width={512} height={512} rx="15%" fill="#f7df1e" />
        <path d="M324 370c10 17 24 29 47 29c20 0 33-10 33 -24c0-16 -13 -22 -35 -32l-12-5c-35-15 -58 -33 -58 -72c0-36 27 -64 70 -64c31 0 53 11 68 39l-37 24c-8-15 -17 -21 -31 -21c-14 0-23 9 -23 21c0 14 9 20 30 29l12 5c41 18 64 35 64 76c0 43-34 67 -80 67c-45 0-74 -21 -88 -49zm-170 4c8 13 14 25 31 25c16 0 26-6 26 -30V203h48v164c0 50-29 72 -72 72c-39 0-61 -20 -72 -44z" />
    </svg>
)


export const Kotlin = () => (
    <svg
        width={width}
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid"
    >
        <defs>
            <linearGradient
                x1="26.599%"
                y1="146.559136%"
                x2="73.8446667%"
                y2="52.3813953%"
                id="linearGradient-1"
            >
                <stop stopColor="#0095D5" offset="9.677%" />
                <stop stopColor="#238AD9" offset="30.07%" />
                <stop stopColor="#557BDE" offset="62.11%" />
                <stop stopColor="#7472E2" offset="86.43%" />
                <stop stopColor="#806EE3" offset="100%" />
            </linearGradient>
            <linearGradient
                x1="13.9840532%"
                y1="37.1049231%"
                x2="68.682392%"
                y2="-13.5538462%"
                id="linearGradient-2"
            >
                <stop stopColor="#0095D5" offset="11.83%" />
                <stop stopColor="#3C83DC" offset="41.78%" />
                <stop stopColor="#6D74E1" offset="69.62%" />
                <stop stopColor="#806EE3" offset="83.33%" />
            </linearGradient>
            <linearGradient
                x1="-16.8361667%"
                y1="91.9396667%"
                x2="76.2191667%"
                y2="-1.11566667%"
                id="linearGradient-3"
            >
                <stop stopColor="#C757BC" offset="10.75%" />
                <stop stopColor="#D0609A" offset="21.38%" />
                <stop stopColor="#E1725C" offset="42.54%" />
                <stop stopColor="#EE7E2F" offset="60.48%" />
                <stop stopColor="#F58613" offset="74.3%" />
                <stop stopColor="#F88909" offset="82.32%" />
            </linearGradient>
        </defs>
        <g>
            <polygon
                fill="url(#linearGradient-1)"
                points="0 256 128.426667 127.573333 256 256"
            />
            <polygon
                fill="url(#linearGradient-2)"
                points="0 0 128.426667 0 0 138.666667"
            />
            <polygon
                fill="url(#linearGradient-3)"
                points="128.426667 0 0 135.253333 0 256 128.426667 127.573333 256 0"
            />
        </g>
    </svg>
)


export const Java = () => (
    <svg
        width={width}
        viewBox="-45 0 346 346"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid">
        <g>
            <path
                d="M82.5539491,267.472524 C82.5539491,267.472524 69.35552,275.147869 91.9468218,277.745105 C119.315549,280.867375 133.303389,280.419607 163.463913,274.711273 C163.463913,274.711273 171.393396,279.683258 182.467491,283.989644 C114.855564,312.966982 29.4483782,282.311215 82.5539491,267.472524"
                fill="#5382A1"
            />
            <path
                d="M74.2921309,229.658996 C74.2921309,229.658996 59.4888145,240.616727 82.0968727,242.955171 C111.333004,245.971316 134.421411,246.218007 174.373236,238.524975 C174.373236,238.524975 179.899113,244.127185 188.588218,247.190807 C106.841367,271.094691 15.79008,249.075898 74.2921309,229.658996"
                fill="#5382A1"
            />
            <path
                d="M143.941818,165.514705 C160.601367,184.695156 139.564684,201.955142 139.564684,201.955142 C139.564684,201.955142 181.866124,180.117876 162.438982,152.772422 C144.294633,127.271098 130.380335,114.600495 205.706705,70.9138618 C205.706705,70.9138618 87.4691491,100.44416 143.941818,165.514705"
                fill="#E76F00"
            />
            <path
                d="M233.364015,295.441687 C233.364015,295.441687 243.131113,303.489396 222.60736,309.715316 C183.580858,321.537862 60.1748945,325.107898 25.8932364,310.186356 C13.5698618,304.825251 36.67968,297.385425 43.9491491,295.824291 C51.5304727,294.180305 55.8629236,294.486575 55.8629236,294.486575 C42.15808,284.832116 -32.7195927,313.443607 17.8287709,321.637469 C155.681513,343.993251 269.121164,311.570618 233.364015,295.441687"
                fill="#5382A1"
            />
            <path
                d="M88.9008873,190.479825 C88.9008873,190.479825 26.1287564,205.389265 66.6717091,210.803433 C83.7901964,213.095331 117.915462,212.576815 149.702284,209.913484 C175.680233,207.722124 201.765236,203.062924 201.765236,203.062924 C201.765236,203.062924 192.605091,206.985775 185.977949,211.510924 C122.233949,228.275665 -0.907636364,220.476509 34.5432436,203.328233 C64.5241018,188.83584 88.9008873,190.479825 88.9008873,190.479825"
                fill="#5382A1"
            />
            <path
                d="M201.506444,253.422313 C266.305164,219.7504 236.344785,187.392 215.432844,191.751447 C210.307258,192.818269 208.021876,193.742662 208.021876,193.742662 C208.021876,193.742662 209.924655,190.761891 213.558924,189.471651 C254.929455,174.927127 286.746065,232.368873 200.204102,255.11936 C200.204102,255.120291 201.206691,254.223825 201.506444,253.422313"
                fill="#5382A1"
            />
            <path
                d="M162.438982,0.371432727 C162.438982,0.371432727 198.325527,36.27008 128.402153,91.4720582 C72.3307055,135.753542 115.616116,161.001658 128.37888,189.848669 C95.6490473,160.318371 71.6297309,134.322735 87.7437673,110.128407 C111.395375,74.6132945 176.918342,57.3942691 162.438982,0.371432727"
                fill="#E76F00"
            />
            <path
                d="M95.2683055,344.665367 C157.466996,348.646865 252.980131,342.45632 255.24224,313.025629 C255.24224,313.025629 250.893964,324.182575 203.838371,333.042967 C150.750487,343.033484 85.2740655,341.867055 46.4393309,335.464262 C46.4402618,335.463331 54.3892945,342.043927 95.2683055,344.665367"
                fill="#5382A1"
            />
        </g>
    </svg>
)


export const Csharp = () => (
    <svg
        width={width}
        viewBox="-16 0 288 288"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid">
        <g>
            <path
                d="M255.569,84.452376 C255.567,79.622376 254.534,75.354376 252.445,71.691376 C250.393,68.089376 247.32,65.070376 243.198,62.683376 C209.173,43.064376 175.115,23.505376 141.101,3.86637605 C131.931,-1.42762395 123.04,-1.23462395 113.938,4.13537605 C100.395,12.122376 32.59,50.969376 12.385,62.672376 C4.064,67.489376 0.015,74.861376 0.013,84.443376 C0,123.898376 0.013,163.352376 0,202.808376 C0,207.532376 0.991,211.717376 2.988,215.325376 C5.041,219.036376 8.157,222.138376 12.374,224.579376 C32.58,236.282376 100.394,275.126376 113.934,283.115376 C123.04,288.488376 131.931,288.680376 141.104,283.384376 C175.119,263.744376 209.179,244.186376 243.209,224.567376 C247.426,222.127376 250.542,219.023376 252.595,215.315376 C254.589,211.707376 255.582,207.522376 255.582,202.797376 C255.582,202.797376 255.582,123.908376 255.569,84.452376"
                fill="#A179DC"
                fillRule="nonzero"/>
            <path
                d="M128.182,143.241376 L2.988,215.325376 C5.041,219.036376 8.157,222.138376 12.374,224.579376 C32.58,236.282376 100.394,275.126376 113.934,283.115376 C123.04,288.488376 131.931,288.680376 141.104,283.384376 C175.119,263.744376 209.179,244.186376 243.209,224.567376 C247.426,222.127376 250.542,219.023376 252.595,215.315376 L128.182,143.241376"
                fill="#280068"
                fillRule="nonzero"/>
            <path
                d="M255.569,84.452376 C255.567,79.622376 254.534,75.354376 252.445,71.691376 L128.182,143.241376 L252.595,215.315376 C254.589,211.707376 255.58,207.522376 255.582,202.797376 C255.582,202.797376 255.582,123.908376 255.569,84.452376"
                fill="#390091"
                fillRule="nonzero"/>
            <path
                d="M201.892326,116.294008 L201.892326,129.767692 L215.36601,129.767692 L215.36601,116.294008 L222.102852,116.294008 L222.102852,129.767692 L235.576537,129.767692 L235.576537,136.504534 L222.102852,136.504534 L222.102852,149.978218 L235.576537,149.978218 L235.576537,156.71506 L222.102852,156.71506 L222.102852,170.188744 L215.36601,170.188744 L215.36601,156.71506 L201.892326,156.71506 L201.892326,170.188744 L195.155484,170.188744 L195.155484,156.71506 L181.6818,156.71506 L181.6818,149.978218 L195.155484,149.978218 L195.155484,136.504534 L181.6818,136.504534 L181.6818,129.767692 L195.155484,129.767692 L195.155484,116.294008 L201.892326,116.294008 Z M215.36601,136.504534 L201.892326,136.504534 L201.892326,149.978218 L215.36601,149.978218 L215.36601,136.504534 Z"
                fill="#FFFFFF"/>
            <path
                d="M128.456752,48.625876 C163.600523,48.625876 194.283885,67.7121741 210.718562,96.0819435 L210.558192,95.808876 L169.209615,119.617159 C161.062959,105.823554 146.128136,96.5150717 128.996383,96.3233722 L128.456752,96.3203544 C102.331178,96.3203544 81.1506705,117.499743 81.1506705,143.625316 C81.1506705,152.168931 83.4284453,160.17752 87.3896469,167.094792 C95.543745,181.330045 110.872554,190.931398 128.456752,190.931398 C146.149522,190.931398 161.565636,181.208041 169.67832,166.820563 L169.481192,167.165876 L210.767678,191.083913 C194.51328,219.21347 164.25027,238.240861 129.514977,238.620102 L128.456752,238.625876 C93.2021701,238.625876 62.4315028,219.422052 46.0382398,190.902296 C38.0352471,176.979327 33.4561922,160.837907 33.4561922,143.625316 C33.4561922,91.1592636 75.9884604,48.625876 128.456752,48.625876 Z"
                fill="#FFFFFF"
                fillRule="nonzero"/>
        </g>
    </svg>
)


export const Level = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <circle
            style={{
                fill: "#5A6B96",
            }}
            cx={256}
            cy={256}
            r={245.106}
        />
        <path
            style={{
                fill: "#EFEFEF",
            }}
            d="M256,457.532c-111.125,0-201.532-90.406-201.532-201.532S144.875,54.468,256,54.468 S457.532,144.875,457.532,256S367.125,457.532,256,457.532z"
        />
        <path
            style={{
                fill: "#FF7D46",
            }}
            d="M457.536,256c0,55.557-22.604,105.951-59.098,142.434l-53.891-53.891 c22.681-22.681,36.733-54.011,36.733-88.543s-14.053-65.863-36.733-88.543l53.891-53.891 C434.932,150.049,457.536,200.443,457.536,256z"
        />
        <path
            style={{
                fill: "#FBC640",
            }}
            d="M398.438,113.566l-53.891,53.891c-22.681-22.681-54.011-36.733-88.543-36.733 c-34.544,0-65.863,14.053-88.543,36.733l-53.891-53.891c36.483-36.494,86.877-59.098,142.434-59.098S361.956,77.072,398.438,113.566 z"
        />
        <path
            style={{
                fill: "#30C9B0",
            }}
            d="M130.728,256c0,34.533,14.053,65.863,36.733,88.543l-53.891,53.891 C77.077,361.951,54.472,311.557,54.472,256s22.604-105.951,59.098-142.434l53.891,53.891 C144.781,190.137,130.728,221.467,130.728,256z"
        />
        <path
            style={{
                fill: "#EFEFEF",
            }}
            d="M246.799,204.924c24.062-0.421,43.908,18.746,44.328,42.808c0.42,24.062-18.746,43.908-42.808,44.328 S56.651,251.824,56.651,251.824S222.737,205.344,246.799,204.924z"
        />
        <g>
            <path
                style={{
                    fill: "#231F20",
                }}
                d="M437.019,74.981C388.668,26.629,324.38,0,256,0S123.332,26.629,74.981,74.981 C26.628,123.333,0,187.62,0,256s26.628,132.668,74.981,181.019C123.332,485.372,187.62,512,256,512s132.668-26.628,181.019-74.981 C485.372,388.668,512,324.38,512,256S485.372,123.333,437.019,74.981z M256,490.213C126.855,490.213,21.787,385.145,21.787,256 S126.855,21.787,256,21.787S490.213,126.855,490.213,256S385.145,490.213,256,490.213z"
            />
            <path
                style={{
                    fill: "#231F20",
                }}
                d="M340.4,389.913c-2.858-5.293-9.467-7.266-14.762-4.409c-21.271,11.488-45.352,17.559-69.639,17.559 c-6.017,0-10.894,4.877-10.894,10.894c0,6.017,4.877,10.894,10.894,10.894c27.89,0,55.551-6.976,79.992-20.176 C341.286,401.816,343.259,395.207,340.4,389.913z"
            />
            <path
                style={{
                    fill: "#231F20",
                }}
                d="M205.376,394.086c-0.881-0.325-1.758-0.657-2.632-0.997c-5.606-2.185-11.921,0.585-14.107,6.191 c-2.186,5.606,0.586,11.921,6.191,14.107c1.003,0.391,2.012,0.773,3.024,1.146c1.242,0.456,2.512,0.673,3.762,0.673 c4.435,0,8.603-2.73,10.225-7.134C213.916,402.425,211.022,396.164,205.376,394.086z"
            />
            <path
                style={{
                    fill: "#231F20",
                }}
                d="M468.43,256c0-56.662-22.122-109.982-62.29-150.138c-0.002-0.002-0.005-0.004-0.008-0.008 c-40.155-40.161-93.471-62.28-150.128-62.28c-56.66,0-109.979,22.121-150.135,62.286c0,0,0,0.001-0.001,0.001l-0.001,0.001 l-0.001,0.001l0,0C65.699,146.021,43.579,199.34,43.579,256s22.121,109.979,62.286,150.135l-0.073,0.073 c82.825,82.825,217.59,82.825,300.415,0l-0.069-0.069c0,0,0.001,0,0.001-0.001C446.309,365.982,468.43,312.662,468.43,256z  M398.226,382.815l-38.572-38.572c21.046-24.627,32.522-55.569,32.522-88.243s-11.474-63.614-32.521-88.243l19.393-19.394 l19.179-19.178c31.303,34.989,48.417,79.611,48.417,126.815S429.529,347.826,398.226,382.815z M256.004,65.362 c47.204,0,91.826,17.113,126.815,48.417l-38.572,38.572c-24.626-21.046-55.568-32.521-88.243-32.521s-63.615,11.474-88.243,32.522 l-38.572-38.572C164.179,82.476,208.8,65.362,256.004,65.362z M246.99,215.816c18.049-0.358,32.93,14.089,33.246,32.106 c0.314,18.018-14.089,32.931-32.106,33.246c-0.1,0.001-0.202,0.002-0.308,0.002c-14.24,0-85.511-15.615-147.381-30.111 C162.228,234.289,233.507,216.051,246.99,215.816z M121.676,278.345c4.002,24.308,14.504,46.97,30.68,65.898l-38.572,38.572 c-29.267-32.711-46.126-73.844-48.197-117.631C78.218,268.211,98.751,273.086,121.676,278.345z M66.238,237.851 c3.806-40.422,20.287-78.198,47.546-108.666l38.572,38.572c-13.594,15.907-23.173,34.453-28.267,54.394 C100.686,228.369,79.471,234.189,66.238,237.851z M129.13,398.283l46.035-46.035c2.043-2.043,3.191-4.814,3.191-7.703 s-1.148-5.66-3.191-7.703c-14.937-14.936-25.212-33.257-30.157-53.204c43.938,9.838,89.747,19.321,103.057,19.32 c0.153,0,0.303-0.001,0.447-0.003c30.029-0.524,54.032-25.382,53.508-55.411c-0.523-30.028-25.376-53.992-55.409-53.509l0,0 c-12.214,0.214-55.187,10.572-97.641,21.585c5.666-14.995,14.504-28.763,26.197-40.457c21.627-21.631,50.337-33.544,80.837-33.544 s59.21,11.912,80.84,33.543c0.001,0.001,0.003,0.002,0.004,0.004c21.627,21.63,33.538,50.338,33.538,80.836 c0,30.5-11.913,59.21-33.543,80.84c-4.254,4.254-4.254,11.152,0,15.406l46.031,46.032 C310.807,462.626,201.202,462.627,129.13,398.283z"
            />
        </g>
    </svg>
)


export const Trophy = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512.004 512.004"
        xmlSpace="preserve">
        <path
            style={{
                fill: "#F5AC51",
            }}
            d="M450.656,2.938C449.078,1.074,446.759,0,444.317,0h-27.693c-4.589,0-8.308,3.719-8.308,8.308 s3.719,8.308,8.308,8.308h17.885l-19.022,114.135c-5.89,35.334-39.824,64.082-75.646,64.082h-83.84v16.616h83.84 c43.583,0,84.869-34.974,92.035-77.965l20.635-123.81C452.914,7.266,452.234,4.801,450.656,2.938z"
        />
        <path
            style={{
                fill: "#FFD159",
            }}
            d="M172.163,194.833c-35.822,0-69.756-28.747-75.646-64.082L77.496,16.616h17.885 c4.589,0,8.308-3.719,8.308-8.308S99.971,0,95.382,0H67.688c-2.443,0-4.761,1.074-6.34,2.938s-2.258,4.327-1.855,6.736 l20.635,123.81c7.166,42.991,48.452,77.965,92.035,77.965h83.84v-16.616L172.163,194.833L172.163,194.833z"
        />
        <polygon
            style={{
                fill: "#F5AC51",
            }}
            points="239.387,307.395 239.387,366.04 272.619,366.04 272.619,307.395 256.003,296.318 "
        />
        <rect
            x={239.383}
            y={249.727}
            style={{
                fill: "#F1866D",
            }}
            width={33.232}
            height={57.668}
        />
        <path
            style={{
                fill: "#F5AC51",
            }}
            d="M339.082,8.308l-83.08,265.855c39.601,0,77.33-31.96,83.84-71.023L372.314,8.308H339.082z"
        />
        <path
            style={{
                fill: "#FFD159",
            }}
            d="M315.888,203.14L339.082,8.308H139.691l32.472,194.832c6.51,39.063,44.238,71.023,83.84,71.023 C284.29,274.163,311.237,242.203,315.888,203.14z"
        />
        <path
            style={{
                fill: "#F5AC51",
            }}
            d="M256.003,340.302l16.616,72.003l33.232-22.155C305.85,362.619,283.533,340.302,256.003,340.302z"
        />
        <path
            style={{
                fill: "#FFD159",
            }}
            d="M256.003,340.302c-27.53,0-49.848,22.317-49.848,49.848l66.464,22.155V390.15 C272.619,362.619,265.179,340.302,256.003,340.302z"
        />
        <path
            style={{
                fill: "#F1866D",
            }}
            d="M305.85,390.15h-33.232l44.309,66.464h33.232v-22.155C350.16,409.988,330.321,390.15,305.85,390.15z"
        />
        <path
            style={{
                fill: "#F5AC51",
            }}
            d="M272.619,390.15h-66.464c-24.471,0-44.309,19.838-44.309,44.309v22.155h155.082v-22.155 C316.928,409.988,297.089,390.15,272.619,390.15z"
        />
        <polygon
            style={{
                fill: "#164370",
            }}
            points="350.16,434.459 328.005,473.229 350.16,512 383.392,512 383.392,434.459 "
        />
        <rect
            x={128.61}
            y={434.463}
            style={{
                fill: "#276AAD",
            }}
            width={221.546}
            height={77.541}
        />
        <g>
            <circle
                style={{
                    fill: "#F5AC51",
                }}
                cx={228.306}
                cy={49.848}
                r={8.308}
            />
            <circle
                style={{
                    fill: "#F5AC51",
                }}
                cx={195.074}
                cy={83.08}
                r={8.308}
            />
            <path
                style={{
                    fill: "#F5AC51",
                }}
                d="M375.084,16.616H136.921c-4.589,0-8.308-3.719-8.308-8.308S132.332,0,136.921,0h238.162 c4.589,0,8.308,3.719,8.308,8.308S379.673,16.616,375.084,16.616z"
            />
        </g>
        <path
            style={{
                fill: "#FFD159",
            }}
            d="M275.388,315.703h-38.771c-4.589,0-8.308-3.719-8.308-8.308s3.719-8.308,8.308-8.308h38.771 c4.589,0,8.308,3.719,8.308,8.308S279.977,315.703,275.388,315.703z"
        />
    </svg>
)


export const Hourglass = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 496 496"
        xmlSpace="preserve">
        <path
            style={{
                fill: "#32AAC6",
            }}
            d="M108,24c7.2,88,67.2,223.2,140,223.2S380.8,112,388,24H108z"
        />
        <path
            style={{
                fill: "#1589AD",
            }}
            d="M246.4,247.2C319.2,247.2,380.8,112,388,24H240"
        />
        <path
            style={{
                fill: "#EFB143",
            }}
            d="M125.6,104c24,72,68.8,143.2,122.4,143.2c52,0,96.8-71.2,121.6-143.2H125.6z"
        />
        <path
            style={{
                fill: "#E28413",
            }}
            d="M252,247.2c48.8,0,94.4-71.2,118.4-143.2H200"
        />
        <path
            style={{
                fill: "#32AAC6",
            }}
            d="M406.4,11.2c0,6.4-7.2,12.8-13.6,12.8H103.2c-6.4,0-13.6-6.4-13.6-12.8l0,0C89.6,4.8,96,0,103.2,0 h290.4C400,0,406.4,4.8,406.4,11.2L406.4,11.2z"
        />
        <path
            style={{
                fill: "#1589AD",
            }}
            d="M406.4,11.2L406.4,11.2c0,7.2-6.4,12.8-13.6,12.8H103.2c-7.2,0-13.6-5.6-13.6-12.8l0,0"
        />
        <path
            style={{
                fill: "#E28413",
            }}
            d="M388,472c-7.2-88-67.2-223.2-140-223.2S115.2,384,108,472H388z"
        />
        <path
            style={{
                fill: "#EFB143",
            }}
            d="M249.6,248.8C176.8,248.8,115.2,384,108,472h148"
        />
        <path
            style={{
                fill: "#1589AD",
            }}
            d="M370.4,392c-24-72-68-143.2-122.4-143.2c-52,0-96.8,71.2-121.6,143.2H370.4z"
        />
        <path
            style={{
                fill: "#32AAC6",
            }}
            d="M248,248.8c-56,0-98.4,71.2-122.4,143.2H296"
        />
        <path
            style={{
                fill: "#1589AD",
            }}
            d="M89.6,484c0-7.2,6.4-12,13.6-12h289.6c7.2,0,13.6,4.8,13.6,12l0,0c0,7.2-6.4,12-13.6,12H103.2 C96,496,89.6,491.2,89.6,484L89.6,484z"
        />
        <path
            style={{
                fill: "#32AAC6",
            }}
            d="M89.6,484.8L89.6,484.8c0-7.2,6.4-12.8,13.6-12.8h289.6c7.2,0,13.6,5.6,13.6,12.8l0,0"
        />
        <path
            style={{
                fill: "#EFB143",
            }}
            d="M256,353.6c0,4.8-3.2,8-8,8l0,0c-4.8,0-8-4-8-8V246.4c0-4.8,3.2-8,8-8l0,0c4.8,0,8,4,8,8V353.6z"
        />
        <path
            style={{
                fill: "#E28413",
            }}
            d="M248,238.4L248,238.4c4.8,0,8,4,8,8v112c0,4.8-4,8-8,8l0,0"
        />
        <circle
            style={{
                fill: "#EFB143",
            }}
            cx={248}
            cy={368.8}
            r={18.4}
        />
        <path
            style={{
                fill: "#E28413",
            }}
            d="M260.8,356c7.2,7.2,7.2,18.4,0,25.6s-18.4,7.2-25.6,0"
        />
    </svg>
)


export const HandShake = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 490.01 490.01"
        xmlSpace="preserve"
    >
        <g>
            <g>
                <rect
                    id="XMLID_60_"
                    x={-14.319}
                    y={147.421}
                    transform="matrix(0.3244 -0.9459 0.9459 0.3244 -125.6895 185.1588)"
                    style={{
                        fill: "#A7A9AC",
                    }}
                    width={162.194}
                    height={66.298}
                />
                <path d="M169.994,106.097l-6.1,3c-7.6,3.7-16.5,4.2-24.4,1.4l-10.2-3.6c-0.6-0.4-1.2-0.7-1.8-0.9l-62.8-21.5 c-4.7-1.6-9.9,0.9-11.5,5.6l-52.7,153.5c-0.8,2.3-0.6,4.8,0.4,6.9s2.9,3.8,5.2,4.6l62.7,21.5c1,0.3,2,0.5,2.9,0.5 c3.8,0,7.3-2.4,8.6-6.1l49.7-144.6l3.4,1.2c12.5,4.4,26.5,3.6,38.5-2.2l6.1-3c7.5-3.7,16.3-4.2,24.2-1.5l115.3,39.7 c-1.2,4.8-3.6,10.5-8,13.6c-4.9,3.4-12.2,3.4-21.8,0.1l-51.4-17.6c-2.4-0.8-5-0.6-7.2,0.6c-2.2,1.2-3.8,3.3-4.5,5.7 c-0.1,0.3-7.2,26.9-29.9,39.1c-14.3,7.7-32.1,8-53,0.9c-4.7-1.6-9.9,0.9-11.5,5.6c-1.6,4.7,0.9,9.9,5.6,11.5 c12,4.1,23.3,6.2,33.8,6.2c12.2,0,23.4-2.7,33.6-8.2c20.3-10.9,30.8-30,35.6-41.4l42.9,14.7c15.3,5.3,28.1,4.5,38-2.4 c15.9-11,16.7-33.3,16.8-34.3c0.1-4-2.4-7.5-6.1-8.8l-122.4-42.2C195.694,99.497,181.794,100.397,169.994,106.097z  M66.194,256.497l-45.6-15.6l46.7-136.3l45.6,15.6L66.194,256.497z" />
                <rect
                    id="XMLID_142_"
                    x={334.311}
                    y={148.377}
                    transform="matrix(-0.4395 -0.8982 0.8982 -0.4395 434.9314 634.4379)"
                    style={{
                        fill: "#3C92CA",
                    }}
                    width={162.188}
                    height={66.294}
                />
                <path d="M410.194,266.797l-21.5,19.8c-19.5,17.9-41.5,33-65.3,44.6l-114.1,55.8c-5,2.5-11.1,0.4-13.6-4.7 c-2.5-5-0.4-11.1,4.7-13.6l1.4-0.7l0,0l62.4-30.5c4.5-2.2,6.4-7.6,4.2-12.1c-2.2-4.5-7.6-6.4-12.1-4.2l-62.4,30.5l0,0l-31.4,15.4 c-5,2.5-11.1,0.4-13.6-4.7c-1.2-2.4-1.4-5.2-0.5-7.7c0.9-2.6,2.7-4.6,5.1-5.8l23.7-11.6l0,0l67.8-33.2c4.5-2.2,6.4-7.6,4.2-12.1 s-7.6-6.4-12.1-4.2l-67.9,33.3l0,0l-2.6,1.3l-32.4,15.9c-2.4,1.2-5.2,1.4-7.7,0.5c-2.6-0.9-4.6-2.7-5.8-5.1 c-2.5-5-0.4-11.1,4.7-13.6l11.2-5.5l0,0l22.9-11.2l6.4-3.1l0,0l52.6-25.8c4.5-2.2,6.4-7.6,4.2-12.1s-7.6-6.4-12.1-4.2l-57,27.9 l-24.9,12.2c-5,2.4-11.1,0.4-13.6-4.7c-1.2-2.4-1.4-5.2-0.5-7.7c0.9-2.6,2.7-4.6,5.1-5.8l43.5-21.3c4.5-2.2,6.4-7.6,4.2-12.1 s-7.6-6.4-12.1-4.2l-43.5,21.3c-6.8,3.3-11.9,9.1-14.3,16.2s-2,14.8,1.3,21.6c2.1,4.2,5.1,7.7,8.7,10.3c-6.3,8.3-7.9,19.7-3,29.7 c3.3,6.8,9.1,11.9,16.2,14.3c3,1,6,1.5,9,1.5c-0.1,4.5,0.8,9,2.9,13.1c4.9,10,15,15.8,25.4,15.8c4.2,0,8.4-0.9,12.4-2.9l6.4-3.1 c0.3,3.4,1.2,6.7,2.7,9.9c4.9,10,15,15.8,25.4,15.8c4.2,0,8.4-0.9,12.4-2.9l114.1-55.8c25.4-12.4,48.8-28.4,69.6-47.5l25.5-23.5 l58.4-28.6c4.5-2.2,6.4-7.6,4.2-12.1l-71.4-145.5c-1.1-2.2-2.9-3.8-5.2-4.6c-2.3-0.8-4.8-0.6-6.9,0.4l-59.6,29.1 c-4.5,2.2-6.4,7.6-4.2,12.1L410.194,266.797z M405.394,106.197l63.3,129.5l-43.3,21.2l-63.3-129.5L405.394,106.197z" />
            </g>
        </g>
    </svg>
)


export const Running = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 503.467 503.467"

        xmlSpace="preserve">
        <g transform="translate(6 3)">
            <path
                style={{
                    fill: "#AAB1BA",
                }}
                d="M356.667,154.19v34.133c-16.213,0-34.133-1.707-34.133-1.707 C261.947,178.083,210.747,138.83,186,85.07c0,0-8.533-18.773-8.533-41.813l25.6-25.6c0,0,17.067,68.267,51.2,102.4 S356.667,154.19,356.667,154.19"
            />
            <path
                style={{
                    fill: "#FF7474",
                }}
                d="M407.867,376.057h17.067c39.253,0,68.267,29.867,68.267,68.267H339.6L58,162.723L177.467,43.257 c0,23.04,8.533,41.813,8.533,41.813c24.747,53.76,75.947,93.013,136.533,101.547c0,0,17.92,1.707,34.133,1.707v136.533 L407.867,376.057z"
            />
            <path
                style={{
                    fill: "#FFE079",
                }}
                d="M321.68,239.523c0,4.267-3.413,8.533-8.533,8.533s-8.533-4.267-8.533-8.533s3.413-8.533,8.533-8.533 S321.68,235.257,321.68,239.523z M313.147,316.323c-5.12,0-8.533-4.267-8.533-8.533s3.413-8.533,8.533-8.533 s8.533,4.267,8.533,8.533S318.267,316.323,313.147,316.323z"
            />
            <path
                style={{
                    fill: "#ECF4F7",
                }}
                d="M493.2,444.323v17.067c0,10.24-7.68,17.067-17.067,17.067H336.187 c-13.653,0-22.187-8.533-22.187-8.533L46.907,202.83c-7.68-7.68-7.68-21.333-0.853-28.16L58,162.724l281.6,281.6L493.2,444.323 L493.2,444.323z"
            />
        </g>
        <path
            style={{
                fill: "#51565F",
            }}
            d="M482.133,485.723h-140.8c-14.507,0-24.747-9.387-24.747-9.387L49.493,209.243 c-4.267-4.267-6.827-11.093-7.68-17.067c0-6.827,2.56-12.8,6.827-17.067l11.093-11.093l0,0l0,0L204.8,18.95 c0.853-0.853,2.56-1.707,4.267-0.853c1.707,0,2.56,1.707,3.413,3.413c0,0.853,17.067,67.413,50.347,100.693 c32.427,32.427,98.987,33.28,98.987,33.28c2.56,0,4.267,1.707,4.267,4.267v168.96l16.213,16.213c1.707,1.707,1.707,4.267,0,5.973 c-1.707,1.707-4.267,1.707-5.973,0l-17.067-17.067c-0.853-0.853-0.853-1.707-0.853-3.413v-12.8h-27.307 c-1.707,5.12-6.827,8.533-11.947,8.533c-6.827,0-12.8-5.973-12.8-12.8s5.973-12.8,12.8-12.8c5.973,0,10.24,3.413,11.947,8.533H358.4 V249.35h-27.307c-1.707,5.12-6.827,8.533-11.947,8.533c-6.827,0-12.8-5.973-12.8-12.8c0-6.827,5.973-12.8,12.8-12.8 c5.973,0,10.24,3.413,11.947,8.533H358.4v-76.8c-16.213-0.853-70.827-5.12-101.547-34.987c-28.16-28.16-45.227-78.507-50.347-97.28 L69.973,168.283l277.333,277.333h147.627c-1.707-34.133-29.013-59.733-64-59.733h-51.2c-2.56,0-4.267-1.707-4.267-4.267 s1.707-4.267,4.267-4.267h51.2c40.96,0,72.533,31.573,72.533,72.533v17.067C503.467,476.337,494.08,485.723,482.133,485.723z  M64,171.697l-8.533,8.533c-2.56,2.56-4.267,6.827-4.267,11.093c0,4.267,1.707,8.533,5.12,11.093L323.413,469.51 c0,0,7.68,7.68,18.773,7.68h140.8c7.68,0,12.8-5.12,12.8-12.8v-12.8H345.6c-0.853,0-2.56-0.853-3.413-0.853L64,171.697z  M319.147,306.523c-2.56,0-4.267,1.707-4.267,4.267s1.707,4.267,4.267,4.267s4.267-1.707,4.267-4.267 S321.707,306.523,319.147,306.523z M319.147,238.257c-2.56,0-4.267,1.707-4.267,4.267c0,2.56,1.707,4.267,4.267,4.267 s4.267-1.707,4.267-4.267C323.413,239.964,321.707,238.257,319.147,238.257z M192,417.457H38.4c-2.56,0-4.267-1.707-4.267-4.267 c0-2.56,1.707-4.267,4.267-4.267H192c2.56,0,4.267,1.707,4.267,4.267C196.267,415.75,194.56,417.457,192,417.457z M140.8,366.257 H4.267c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267H140.8c2.56,0,4.267,1.707,4.267,4.267 S143.36,366.257,140.8,366.257z M277.333,332.123c-2.56,0-4.267-1.707-4.267-4.267v-102.4c0-2.56,1.707-4.267,4.267-4.267 s4.267,1.707,4.267,4.267v102.4C281.6,330.417,279.893,332.123,277.333,332.123z M89.6,315.057H21.333 c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267H89.6c2.56,0,4.267,1.707,4.267,4.267S92.16,315.057,89.6,315.057z  M328.533,193.883C328.533,193.883,327.68,193.883,328.533,193.883c-62.293-8.533-114.347-47.787-140.8-104.107 c-0.853-2.56,0-4.267,1.707-5.973c2.56-0.853,4.267,0,5.973,1.707c24.747,53.76,75.093,90.453,133.12,98.987 c2.56,0,4.267,2.56,3.413,5.12C331.947,192.177,330.24,193.883,328.533,193.883z"
        />
    </svg>
)


export const Settings = () => (
    <svg
        width={width}
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg">
        <rect fill="#fff" height={60} rx={10} width={60} />
        <rect fill="#c1f7fd" height={8} rx={4} width={44} x={8} y={10} />
        <path
            d="M48,19.5H12a5.5,5.5,0,0,1,0-11H48a5.5,5.5,0,0,1,0,11Zm-36-8a2.5,2.5,0,0,0,0,5H48a2.5,2.5,0,0,0,0-5Z"
            fill="#7bcdd1"
        />
        <rect fill="#c1f7fd" height={8} rx={4} width={44} x={8} y={26} />
        <path
            d="M48,35.5H12a5.5,5.5,0,0,1,0-11H48a5.5,5.5,0,0,1,0,11Zm-36-8a2.5,2.5,0,0,0,0,5H48a2.5,2.5,0,0,0,0-5Z"
            fill="#7bcdd1"
        />
        <rect fill="#c1f7fd" height={8} rx={4} width={44} x={8} y={42} />
        <path
            d="M48,51.5H12a5.5,5.5,0,0,1,0-11H48a5.5,5.5,0,0,1,0,11Zm-36-8a2.5,2.5,0,0,0,0,5H48a2.5,2.5,0,0,0,0-5Z"
            fill="#7bcdd1"
        />
        <circle cx={40} cy={14} fill="#ffe1a0" r={6} />
        <path
            d="M40,21.5A7.5,7.5,0,1,1,47.5,14,7.508,7.508,0,0,1,40,21.5Zm0-12A4.5,4.5,0,1,0,44.5,14,4.505,4.505,0,0,0,40,9.5Z"
            fill="#f29580"
        />
        <circle cx={20} cy={30} fill="#ffe1a0" r={6} />
        <path
            d="M20,37.5A7.5,7.5,0,1,1,27.5,30,7.508,7.508,0,0,1,20,37.5Zm0-12A4.5,4.5,0,1,0,24.5,30,4.505,4.505,0,0,0,20,25.5Z"
            fill="#f29580"
        />
        <circle cx={40} cy={46} fill="#ffe1a0" r={6} />
        <path
            d="M40,53.5A7.5,7.5,0,1,1,47.5,46,7.508,7.508,0,0,1,40,53.5Zm0-12A4.5,4.5,0,1,0,44.5,46,4.505,4.505,0,0,0,40,41.5Z"
            fill="#f29580"
        />
        <path
            d="M34,15.5A1.5,1.5,0,0,1,32.5,14,7.508,7.508,0,0,1,40,6.5a1.5,1.5,0,0,1,0,3A4.505,4.505,0,0,0,35.5,14,1.5,1.5,0,0,1,34,15.5Z"
            fill="#f2bf80"
        />
        <path
            d="M34,47.5A1.5,1.5,0,0,1,32.5,46,7.508,7.508,0,0,1,40,38.5a1.5,1.5,0,0,1,0,3A4.505,4.505,0,0,0,35.5,46,1.5,1.5,0,0,1,34,47.5Z"
            fill="#f2bf80"
        />
        <path
            d="M14,31.5A1.5,1.5,0,0,1,12.5,30,7.508,7.508,0,0,1,20,22.5a1.5,1.5,0,0,1,0,3A4.505,4.505,0,0,0,15.5,30,1.5,1.5,0,0,1,14,31.5Z"
            fill="#f2bf80"
        />
    </svg>
)


export const Coins = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <path
            style={{
                fill: "#E6C275",
            }}
            d="M232.95,349.441c0,24.425-50.787,44.227-113.437,44.227S6.076,373.867,6.076,349.441v-81.892H232.95 V349.441z"
        />
        <path
            style={{
                fill: "#FFD782",
            }}
            d="M232.95,267.549c0,24.425-50.787,44.227-113.437,44.227S6.076,291.975,6.076,267.549v-81.892H232.95 V267.549z"
        />
        <g>
            <path
                style={{
                    fill: "#E6C275",
                }}
                d="M232.95,185.656c0,24.425-50.787,44.227-113.437,44.227S6.076,210.083,6.076,185.656v-81.892H232.95 V185.656z"
            />
            <path
                style={{
                    fill: "#E6C275",
                }}
                d="M279.05,349.441c0,24.425,50.787,44.227,113.437,44.227s113.437-19.801,113.437-44.227v-81.892 H279.05V349.441z"
            />
        </g>
        <path
            style={{
                fill: "#FFD782",
            }}
            d="M279.05,267.549c0,24.425,50.787,44.227,113.437,44.227s113.437-19.801,113.437-44.227v-81.892 H279.05V267.549z"
        />
        <path
            style={{
                fill: "#E6C275",
            }}
            d="M279.05,185.656c0,24.425,50.787,44.227,113.437,44.227s113.437-19.801,113.437-44.227v-81.892 H279.05V185.656z"
        />
        <g>
            <ellipse
                style={{
                    fill: "#FFD782",
                }}
                cx={392.488}
                cy={103.767}
                rx={113.443}
                ry={44.226}
            />
            <ellipse
                style={{
                    fill: "#FFD782",
                }}
                cx={119.51}
                cy={103.767}
                rx={113.443}
                ry={44.226}
            />
        </g>
        <path
            style={{
                opacity: 0.1,
            }}
            d="M111.065,162.558v230.987c2.789,0.08,5.606,0.122,8.447,0.122 c62.649,0,113.437-19.801,113.437-44.227v-81.892v-81.892v-81.891c0-5.45-2.535-10.669-7.159-15.49 c-22.81,2.195-43.979,6.856-61.444,13.666C117.988,120.015,111.065,147.678,111.065,162.558z"
        />
        <path
            style={{
                opacity: 0.1,
            }}
            d="M400.934,162.558v230.987c-2.789,0.08-5.606,0.122-8.447,0.122 c-62.649,0-113.437-19.801-113.437-44.227v-81.892v-81.892v-81.891c0-5.45,2.535-10.669,7.159-15.49 c22.81,2.195,43.979,6.856,61.444,13.666C394.012,120.015,400.934,147.678,400.934,162.558z"
        />
        <path
            style={{
                fill: "#E6C275",
            }}
            d="M369.436,408.236c0,24.425-50.787,44.227-113.437,44.227s-113.437-19.801-113.437-44.227v-81.892 h226.875V408.236z"
        />
        <path
            style={{
                fill: "#FFD782",
            }}
            d="M369.436,326.344c0,24.425-50.787,44.227-113.437,44.227s-113.437-19.801-113.437-44.227v-81.892 h226.875V326.344z"
        />
        <path
            style={{
                fill: "#E6C275",
            }}
            d="M369.436,244.451c0,24.425-50.787,44.227-113.437,44.227s-113.437-19.801-113.437-44.227v-81.892 h226.875V244.451z"
        />
        <ellipse
            style={{
                fill: "#FFD782",
            }}
            cx={256.004}
            cy={162.558}
            rx={113.443}
            ry={44.226}
        />
        <path d="M391.535,53.198c-31.037,0-60.333,4.757-82.493,13.398c-24.487,9.547-37.973,23.162-37.973,38.34 c0,2.411,0.333,4.78,0.995,7.101c-5.352-0.301-10.723-0.455-16.064-0.455c-5.417,0-10.777,0.153-16.06,0.439 c0.659-2.316,0.99-4.679,0.99-7.085c0-20.59-22.268-32.383-38.869-38.674c-35.819-13.573-76.479-15.559-114.254-11.239 c-4.29,0.491-7.37,4.366-6.88,8.658c0.491,4.29,4.359,7.366,8.658,6.88c35.392-4.007,74.185-2.456,107.692,10.607 c17.541,6.839,28.014,15.725,28.014,23.77c0,2.807-1.265,5.72-3.766,8.682c-0.091,0.01-0.179,0.024-0.27,0.034 c-4.948,0.606-9.877,1.356-14.782,2.249c-0.241,0.045-0.48,0.092-0.72,0.137c-25.462,4.762-45.911,13.044-57.949,23.632 c-0.92,0.092-1.84,0.182-2.766,0.265c-8.171,0.73-16.369,1.1-24.573,1.1c-28.988,0-61.313-3.252-87.328-17.112 c-10.678-5.688-16.976-12.168-17.466-18.227c-0.02-0.254-0.031-0.508-0.031-0.76c0-10.505,17.183-21.825,43.776-28.84 c4.176-1.102,6.668-5.38,5.566-9.555c-1.102-4.176-5.381-6.667-9.555-5.566C20.202,70.266,0,86.29,0,104.936v81.321v81.321v81.321 c0,33.604,62.067,51.738,120.465,51.738c5.025,0,10.064-0.143,15.069-0.399v7.046c0,33.604,62.067,51.738,120.465,51.738 c31.037,0,60.333-4.757,82.493-13.398c24.487-9.547,37.973-23.163,37.973-38.34v-7.046c5.005,0.256,10.045,0.399,15.069,0.399 c31.037,0,60.333-4.757,82.493-13.398c24.487-9.547,37.973-23.163,37.973-38.34v-81.321v-81.321v-81.321 C512,71.332,449.933,53.198,391.535,53.198z M496.361,131.288v54.969c0,8.045-10.473,16.93-28.014,23.77 c-20.394,7.951-47.673,12.329-76.813,12.329c-2.258,0-4.52-0.036-6.78-0.092c-0.655-0.016-1.309-0.039-1.964-0.058 c-1.709-0.053-3.414-0.122-5.116-0.206c-0.403-0.02-0.806-0.039-1.209-0.06v-58.618c0-2.443-0.337-4.8-0.968-7.078 c0.123,0.006,0.247,0.01,0.37,0.017c32.742,1.695,67.373-0.979,98.16-12.983C481.886,140.212,489.617,136.401,496.361,131.288z  M332.812,349.732c-24.235,9.449-50.954,12.329-76.812,12.329c-29.14,0-56.419-4.379-76.813-12.329 c-17.541-6.839-28.014-15.725-28.014-23.77v-54.829c0.07,0.052,0.144,0.101,0.215,0.153c31.127,23.051,73.031,25.755,110.41,25.036 c32.742-0.629,71.652-4.855,98.734-25.117c0.096-0.072,0.199-0.141,0.294-0.213v54.969c0,0.503-0.041,1.009-0.122,1.518 C359.49,335.108,349.256,343.32,332.812,349.732z M129.04,303.538c-2.858,0.091-5.716,0.139-8.575,0.139 c-59.997,0-104.827-19.058-104.827-36.099v-54.829c0.07,0.052,0.145,0.102,0.215,0.153c0.617,0.458,1.246,0.911,1.894,1.357 c0.05,0.034,0.103,0.068,0.153,0.102C39.63,229.101,67.86,234.3,93.535,236.719c13.56,1.277,27.193,1.576,40.797,0.937 c0.4-0.019,0.804-0.026,1.203-0.046v7.031v58.622c-0.266,0.015-0.534,0.026-0.801,0.04 C132.838,303.399,130.939,303.478,129.04,303.538z M17.748,132.939c21.858,15.148,50.989,20.22,76.946,22.565 c13.776,1.245,27.628,1.483,41.439,0.755c0.136-0.007,0.272-0.011,0.409-0.02c-0.666,2.315-1.006,4.678-1.006,7.081v58.618 c-0.403,0.022-0.807,0.041-1.211,0.06c-28.457,1.399-58.05-0.882-85.189-10.039c-8.594-2.899-17.321-6.533-24.566-12.094 c-4.215-3.235-8.931-7.886-8.931-13.609v-54.829c0.07,0.052,0.145,0.102,0.214,0.153C16.478,132.044,17.109,132.497,17.748,132.939z  M290.474,113.619c-2.501-2.963-3.766-5.876-3.766-8.683c0-8.045,10.473-16.93,28.014-23.77 c20.394-7.951,47.673-12.329,76.813-12.329c29.14,0,56.419,4.379,76.813,12.329c17.541,6.839,28.014,15.725,28.014,23.77 s-10.473,16.93-28.014,23.77c-20.394,7.951-47.673,12.329-76.813,12.329c-9.077,0-18.154-0.45-27.186-1.35 c-5.443-4.789-12.503-8.988-20.721-12.582c-0.414-0.183-0.834-0.365-1.255-0.545c-0.027-0.011-0.053-0.023-0.08-0.034 C328.253,120.515,310.537,116.051,290.474,113.619z M285.862,128.828c22.718,2.505,52.422,7.111,69.458,23.936 c0.023,0.023,0.05,0.039,0.074,0.062c0.043,0.042,0.087,0.082,0.13,0.122c3.446,3.463,5.301,6.993,5.301,10.373 c0,10.623-18.274,22.389-45.474,29.277c-4.187,1.06-6.72,5.313-5.661,9.499c1.06,4.188,5.316,6.719,9.499,5.661 c11.311-2.864,22.533-6.691,32.773-12.344c2.832-1.564,5.578-3.292,8.186-5.207c0.224-0.165,0.457-0.326,0.677-0.492v54.927 c0,0.503-0.041,1.009-0.122,1.518c-1.215,7.63-11.447,15.841-27.893,22.252c-24.244,9.452-50.945,12.329-76.812,12.329 c-29.14,0-56.419-4.379-76.813-12.329c-17.541-6.839-28.014-15.725-28.014-23.77v-54.829c0.07,0.052,0.145,0.102,0.215,0.153 c28.949,21.443,69.703,25.093,104.612,25.093c10.329,0,20.683-0.527,30.953-1.634c8.761-0.945,9.174-14.113,0.373-15.492 c-0.664-0.104-1.35-0.133-2.051-0.058c-9.492,1.025-19.342,1.545-29.276,1.545c-29.14,0-56.419-4.379-76.813-12.329 c-17.54-6.838-28.013-15.724-28.014-23.769c-0.001-13.442,21.868-22.594,32.17-26.171 C215.191,126.093,252.664,125.167,285.862,128.828z M120.465,384.998c-59.997,0-104.827-19.058-104.827-36.099V294.07 c0.07,0.052,0.145,0.102,0.215,0.153c5.824,4.315,12.3,7.642,18.978,10.422c19.859,8.268,41.303,12.013,62.65,13.74 c12.148,0.984,24.365,1.166,36.54,0.607c0.503-0.023,1.01-0.032,1.513-0.057v65.657 C130.536,384.861,125.492,384.998,120.465,384.998z M360.827,407.283c0,8.045-10.473,16.93-28.014,23.77 c-20.394,7.951-47.673,12.329-76.813,12.329s-56.419-4.379-76.813-12.329c-17.541-6.839-28.014-15.725-28.014-23.77v-54.829 c0.07,0.052,0.145,0.102,0.215,0.153c28.931,21.454,69.716,25.092,104.612,25.092c31.037,0,60.333-4.757,82.493-13.398 c7.733-3.015,15.348-6.768,22.04-11.775c0.096-0.072,0.199-0.141,0.294-0.213V407.283z M496.361,348.899 c0,8.045-10.473,16.93-28.014,23.77c-20.394,7.951-47.673,12.329-76.813,12.329c-5.025,0-10.07-0.137-15.069-0.407v-58.629v-7.027 c0.501,0.025,1.009,0.034,1.512,0.057c4.515,0.205,9.037,0.323,13.558,0.323c14.053,0,27.811-0.976,40.891-2.899 c4.272-0.629,7.227-4.601,6.597-8.874c-0.629-4.272-4.596-7.227-8.874-6.597c-12.328,1.813-25.32,2.733-38.614,2.733 c-4.758,0-9.517-0.14-14.27-0.374c-0.267-0.014-0.534-0.025-0.801-0.04v-58.622v-7.031c0.4,0.021,0.803,0.027,1.203,0.046 c22.818,1.073,46.362-0.123,68.883-4.933c17.193-3.672,35.269-9.253,49.516-19.901c0.096-0.072,0.199-0.141,0.294-0.213v54.969 c0,9.361-13.872,19.57-36.204,26.646c-4.116,1.304-6.396,5.699-5.092,9.816c1.303,4.116,5.696,6.4,9.816,5.092 c10.661-3.377,21.133-7.727,30.281-14.248c0.405-0.291,0.808-0.581,1.199-0.875v54.889H496.361z" />
    </svg>
)


export const Percentage = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <circle
            style={{
                fill: "#25B6D2",
            }}
            cx={256}
            cy={256}
            r={256}
        />
        <path
            style={{
                fill: "#FFFFFF",
            }}
            d="M238.464,210.176c0,42.624-26.96,64.896-56.416,64.896c-31.024,0-55.488-23.2-55.488-61.456 c0-36.352,22.256-63.936,57.04-63.936C218.72,149.664,238.464,175.376,238.464,210.176z M161.984,212.352 c0,21.312,7.2,36.672,20.992,36.672c13.488,0,20.064-13.776,20.064-36.672c0-20.688-5.648-36.672-20.368-36.672 C168.56,175.68,161.984,191.984,161.984,212.352z M184.544,360.336L301.488,149.68h25.696L209.936,360.336H184.544z  M385.168,294.816c0,42.624-26.96,64.896-56.416,64.896c-30.72,0-55.168-23.2-55.488-61.456c0-36.352,22.256-63.936,57.04-63.936 C365.424,234.32,385.168,260.016,385.168,294.816z M308.992,296.992c-0.32,21.312,6.896,36.672,20.688,36.672 c13.488,0,20.064-13.776,20.064-36.672c0-20.688-5.328-36.672-20.064-36.672C315.264,260.336,308.992,276.624,308.992,296.992z"
        />
    </svg>
)


export const Medal = () => (
    <svg
        width={width}
        viewBox="-7.72 0 76.029 76.029"
        xmlns="http://www.w3.org/2000/svg">
        <g
            id="medal_gold"
            data-name="medal gold"
            transform="translate(-1075.457 -1001.04)"
        >
            <path
                id="Path_104"
                data-name="Path 104"
                d="M1132.6,1050.226a26.843,26.843,0,1,1-26.847-26.842A26.851,26.851,0,0,1,1132.6,1050.226Z"
                fill="#fdb53f"
            />
            <path
                id="Path_105"
                data-name="Path 105"
                d="M1123.98,1050.226A18.228,18.228,0,1,1,1105.749,1032,18.235,18.235,0,0,1,1123.98,1050.226Z"
                fill="#fc9a42"
            />
            <path
                id="Path_106"
                data-name="Path 106"
                d="M1119.73,1050.226a13.98,13.98,0,1,1-13.981-13.981A13.982,13.982,0,0,1,1119.73,1050.226Z"
                fill="#f9c543"
            />
            <path
                id="Path_107"
                data-name="Path 107"
                d="M1119.192,1001.04l-24.977,24.977a26.621,26.621,0,0,1,25.668,1.423l10.418-10.419,5.747-5.743V1001.04Z"
                fill="#bc4330"
            />
            <path
                id="Path_108"
                data-name="Path 108"
                d="M1091.621,1027.437a26.6,26.6,0,0,1,25.657-1.418l-24.967-24.979h-16.854v10.238l5.741,5.743Z"
                fill="#ff5245"
            />
        </g>
    </svg>
)


export const Marker = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <polygon
            style={{
                fill: "#FFCC75",
            }}
            points="47.202,417.53 94.404,464.732 47.202,511.945 0,464.743 "
        />
        <polygon
            style={{
                fill: "#082947",
            }}
            points="236.149,414.811 212.545,438.4 111.564,368.892 166.634,313.823 "
        />
        <polygon
            style={{
                fill: "#274B6D",
            }}
            points="182.37,329.559 127.301,384.628 73.529,299.384 97.126,275.788 "
        />
        <polygon
            style={{
                fill: "#FF9D49",
            }}
            points="512,118.078 452.926,59.003 294.044,186.413 166.634,345.296 251.886,430.548 "
        />
        <path
            style={{
                fill: "#274B6D",
            }}
            d="M143.037,368.892l69.508,69.508c0,0-61.136,0.802-102.397,42.063l-39.35-39.333l20.383-51.855 L143.037,368.892z"
        />
        <polygon
            style={{
                fill: "#FFCC75",
            }}
            points="393.977,0.055 81.39,260.051 166.634,345.296 452.926,59.003 "
        />
        <path
            style={{
                fill: "#185F8D",
            }}
            d="M73.529,299.384l69.508,69.508l-72.239,72.239L31.458,401.79 C72.719,360.529,73.529,299.384,73.529,299.384z"
        />
    </svg>
)


export const Numbering = () => (
    <svg
        width={width}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <g>
            <path
                style={{
                    fill: "#00D7DF",
                }}
                d="M41.253,151.36c6.99,0,12.466-5.068,12.466-11.538V49.123c0-6.394-5.243-11.402-11.935-11.402 c-5.888,0-8.833,3.951-9.801,5.249c-0.04,0.055-0.081,0.11-0.119,0.165L21.327,58.042c-2.047,2.225-3.865,5.783-3.865,9.197 c0,6.505,5.059,11.812,11.321,11.933v60.65C28.782,146.4,34.142,151.36,41.253,151.36z"
            />
            <path
                style={{
                    fill: "#00D7DF",
                }}
                d="M25.557,254.952c-11.929,8.591-25.449,18.33-25.449,33.39v12.934 c0,6.904,6.313,11.541,12.211,11.541h47.479c6.215,0,11.271-5.475,11.271-12.205c0-6.659-5.057-12.076-11.271-12.076H25.323v-0.197 c0-3.626,8.312-9.491,14.991-14.204c13.286-9.376,29.821-21.043,29.821-41.277c0-19.202-14.882-33.68-34.614-33.68 c-18.894,0-33.143,12.988-33.143,30.211c0,9.994,6.505,13.542,12.075,13.542c7.973,0,12.737-5.935,12.737-11.673 c0-3.568,0.915-7.663,8.063-7.663c9.654,0,9.931,8.554,9.931,9.529C45.186,240.813,35.208,248.001,25.557,254.952z"
            />
            <path
                style={{
                    fill: "#00D7DF",
                }}
                d="M35.326,450.064c-9.822,0-10.585-5.058-10.585-6.608c0-5.863-3.886-11.777-12.57-11.777 C4.55,431.678,0,436.428,0,444.384c0,14.493,12.424,29.896,35.453,29.896c22.368,0,35.724-13.451,35.724-35.983v-2.516 c0-9.239-2.955-16.897-8.501-22.404c3.799-5.498,5.856-12.828,5.856-21.382c0-19.927-11.765-31.355-32.282-31.355 c-26.897,0-34.006,19.21-34.006,29.368c0,11.825,8.791,13.102,12.571,13.102c7.361,0,12.305-4.945,12.305-12.306 c0-2.83,1.008-6.081,8.859-6.081c5.643,0,7.941,0.812,7.941,8.99c0,7.989-1.715,8.859-8.469,8.859 c-6.487,0-11.378,5.118-11.378,11.908c0,6.715,4.95,11.778,11.514,11.778c8.919,0,10.713,3.643,10.713,9.521v2.516 C46.302,448.188,42.444,450.064,35.326,450.064z"
            />
        </g>
        <g>
            <path
                style={{
                    fill: "#424EDE",
                }}
                d="M164.864,86.468h322.917C501.156,86.468,512,75.625,512,62.25s-10.844-24.219-24.219-24.219H164.864 c-13.375,0-24.219,10.844-24.219,24.219S151.489,86.468,164.864,86.468z"
            />
            <path
                style={{
                    fill: "#424EDE",
                }}
                d="M164.864,183.344h322.917c13.375,0,24.219-10.844,24.219-24.219s-10.844-24.219-24.219-24.219 H164.864c-13.375,0-24.219,10.844-24.219,24.219S151.489,183.344,164.864,183.344z"
            />
            <path
                style={{
                    fill: "#424EDE",
                }}
                d="M164.864,280.219h322.917C501.156,280.219,512,269.375,512,256 c0-13.375-10.844-24.219-24.219-24.219H164.864c-13.375,0-24.219,10.844-24.219,24.219 C140.645,269.375,151.489,280.219,164.864,280.219z"
            />
            <path
                style={{
                    fill: "#424EDE",
                }}
                d="M164.864,473.969h322.917c13.375,0,24.219-10.844,24.219-24.219 c0-13.375-10.844-24.219-24.219-24.219H164.864c-13.375,0-24.219,10.844-24.219,24.219 C140.645,463.126,151.489,473.969,164.864,473.969z"
            />
            <path
                style={{
                    fill: "#424EDE",
                }}
                d="M164.864,377.094h322.917c13.375,0,24.219-10.844,24.219-24.219 c0-13.375-10.844-24.219-24.219-24.219H164.864c-13.375,0-24.219,10.844-24.219,24.219 C140.645,366.25,151.489,377.094,164.864,377.094z"
            />
        </g>
    </svg>
)
